import type { ProblemDetails } from './types';

const KNOWN_MESSAGES: Record<string, string> = {
  'Users.NoPermissionsAssigned':
    'You do not have access entitlements yet. Ask your organization administrator to assign you a role.',
};

export function resolveProblemDetailsMessage(data: ProblemDetails, fallback: string): string {
  const title = data.title?.trim();
  if (title && KNOWN_MESSAGES[title]) {
    return KNOWN_MESSAGES[title];
  }

  const detail = data.detail?.trim();
  if (detail && detail !== 'An unexpected error occurred') {
    return detail;
  }

  if (title && title !== 'Server failure') {
    return title;
  }

  return fallback;
}
